// extracted by mini-css-extract-plugin
export default {"container":"Indices_container__ecBnn","tvcontainer":"Indices_tvcontainer__peo66"};